module.exports = "/_next/static/images/50c87a0a6ca673dbd3a7f67ceb4e5093-cartao-proximo-ao-olho-md@1x.jpg";